import Image from 'next/image';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import capterraLogo from '/public/images/signup/capterra-logo.svg';
import getappLogo from '/public/images/signup/getapp-logo.svg';
import starIcon from '/public/images/signup/star-icon.svg';

const TrustBadge = () => {
    const { t } = useTranslation('signup_funnel');
    return (
        <div className="flex items-center gap-3 rounded-full border border-icoGray-300 bg-white px-5 py-2.5 pl-3">
            <div className="flex items-center gap-3">
                <div className="flex items-center gap-2">
                    <Image src={capterraLogo} alt="Capterra" width={16} height={16} />
                    <div className="flex items-center justify-center gap-1 rounded-full bg-icoGray-300 px-2 py-1.5">
                        <Image src={starIcon} alt="" width={10} height={10} />
                        <span className="font-GSemiBold text-xs leading-[14px] tracking-[-0.3px] text-icoGray-500">
                            4.5/5
                        </span>
                    </div>
                </div>
                <div className="h-5 w-px bg-icoGray-300" />
                <div className="flex items-center gap-2">
                    <Image src={getappLogo} alt="GetApp" width={16} height={16} />
                    <div className="flex items-center justify-center gap-1 rounded-full bg-icoGray-300 px-2 py-1.5">
                        <Image src={starIcon} alt="" width={10} height={10} />
                        <span className="font-GSemiBold text-xs leading-[14px] tracking-[-0.3px] text-icoGray-500">
                            4.4/5
                        </span>
                    </div>
                </div>
            </div>
            <span className="font-GSemiBold text-xs leading-[14px] tracking-[-0.3px] text-icoGray-500">
                {t('trusted_by_brands')}
            </span>
        </div>
    );
};

export default TrustBadge;
